import { gql } from "@apollo/client";

export const levelQuery = gql`
  query($scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      levels {
        id
        level
      }
    }
  }
`;
